<template>
  <div
    class="container-fluid"
    style="
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      max-width: 100%;
      display: flex;
      align-items: center;
    "
  >
    <!--bg-maintenance-image-->

    <QrCode ref="QrCode" :name="'QrCode'" @onQr="getEqInfo" />

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1">
      <div class="card border-grey border-lighten-3 px-1 py-1 box-shadow-3">
        <div class="card-block text-xs-center">
          <span class="card-title text-xs-center">
            <a @click="openURL('https://modern-expo.eu')"
              ><img
                src="../assets/pictures/me_logo.png"
                class="img-fluid mx-auto d-block pt-2"
                width="250"
                alt="logo"
            /></a>
          </span>
        </div>
        <div class="card-block">
          <div class="form-group">
            <label for="serial">Серийный номер</label>
            <div class="row center">
              <div class="col-md-6">
                <div class="position-relative has-icon-left">
                  <input
                    class="form-control border-primary"
                    type="text"
                    id="serial"
                    v-model="serial"
                  />
                  <div class="form-control-position">
                    <i class="icon-qrcode"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="showModalQR()"
                  data-html="true"
                  :title="$t('equipm.hint.scanQr')"
                >
                  <i style="color: #ffffff" class="icon-qrcode"></i> Scan QR
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-block text-xs-center"
            v-show="$store.state.isLoading"
          >
            <div class="mt-2">
              <i class="icon-gear-a spinner font-large-2"></i>
            </div>
          </div>

          <div class="row" v-if="show_questions">
            <form class="form">
              <h4 class="form-section">
                <i class="icon-file-text2"></i> Аудит
              </h4>
            </form>

            <div class="table-responsive">
              <table class="table table-hover mb-0" cellspacing="0">
                <tbody>
                  <tr v-for="(qus, index) in questions" :key="index">
                    <td>{{ qus.question }}</td>
                    <td>
                      <div class="input-group">
                        <label
                          class="display-inline-block custom-control custom-radio ml-1"
                        >
                          <input
                            type="radio"
                            :name="index"
                            v-model="qus.answer"
                            @change="onChangeAnswers()"
                            v-bind:value="true"
                            class="custom-control-input"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description ml-0"
                            >Сделано</span
                          >
                        </label>
                        <label
                          class="display-inline-block custom-control custom-radio"
                        >
                          <input
                            type="radio"
                            :name="index"
                            v-model="qus.answer"
                            @change="onChangeAnswers()"
                            v-bind:value="false"
                            class="custom-control-input"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description ml-0"
                            >Не сделано</span
                          >
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mt-1" v-if="show_props">
            <div class="col-md-8">
              <div class="form-group">
                <label for="checker">Проверил (фамилия)</label>
                <div class="position-relative">
                  <input
                    class="form-control border-primary"
                    type="text"
                    id="checker"
                    v-model="checker"
                    @change="onChangeQuestions()"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="shiftNumber">№ Смены</label>
                <div class="position-relative">
                  <input
                    class="form-control border-primary"
                    type="text"
                    id="shiftNumber"
                    v-model="shiftNumber"
                    @change="onChangeQuestions()"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-1" v-if="showBtnSend">
            <div
              class="col-md-12"
              style="
                display: flex;
                align-content: center;
                justify-content: center;
                margin-bottom: 1em;
              "
            >
              <button
                type="button"
                class="btn btn-warning"
                @click="sendReport()"
              >
                <i class="icon-upload3"></i> Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Audit",
  components: {},
  data() {
    return {
      authorized: false,
      card_numb: null,

      serial: null,

      show_questions: false,
      questions: [
        {
          question:
            "Проверка функционала и внешний вид (отсутствие механических повреждений / наличие всех элементов / покрытие равномерое, без мусора и вкраплений).",
          answer: null,
        },
        {
          question:
            "Проверка наличия всех вытяжных и резьбовых заклепок и визуальная оценка качества клепания.",
          answer: null,
        },
        {
          question:
            "Проверка наличия шайб и втулок под дверями (1 втулка и 1 шайба под каждой дверью / 1 втулка и 2 шайбы под нижней дверью).",
          answer: null,
        },
        {
          question: "Проверка качества лакокрасочного покрытия.",
          answer: null,
        },
        {
          question:
            "Проверка наличия маркировки проводов питания замков (на каждом проводе должен быть пластиковый маркер с номером провода, нумерация идет сверху вниз). Проверка отсутствия механических повреждений цветных проводов штекера.",
          answer: null,
        },
        {
          question:
            "Все провода должны быть зафиксированы стяжкой возле замков и на крыше стека.",
          answer: null,
        },
        {
          question:
            "Проверка наличия винтов заземления на подиуме и монтажных комплектов в упаковке.",
          answer: null,
        },
        {
          question:
            "Проверка открывания закрывания дверей - без рывков и заеданий, соприкасаний и трения с другими элементами.",
          answer: null,
        },
        {
          question:
            "Проверка работы контроллера - соответствие id-номера, управление замками.",
          answer: null,
        },
        {
          question:
            "Короб (соединительная планка) установлен верно - прорезь расположена сверху.",
          answer: null,
        },
      ],

      show_props: false,
      checker: null,
      shiftNumber: null,

      showBtnSend: false,
    };
  },
  methods: {
    getEqInfo(serial) {
      if (this.isValid(serial)) {
        this.serial = serial;
      }
    },
    onChangeAnswers() {
      let checks = 0;
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].answer != null) {
          checks++;
        }
      }

      if (checks == this.questions.length) {
        this.show_props = true;
      } else {
        this.show_props = false;
      }
    },
    onChangeQuestions() {
      if (this.isValid(this.checker) && this.isValid(this.shiftNumber)) {
        this.showBtnSend = true;
      } else {
        this.showBtnSend = false;
      }
    },
    sendReport() {
      let dataRequest = {
        checker: this.checker,
        shiftNumber: this.shiftNumber,
        arrayAnketa: this.questions,
        serial: this.serial,
      };
      this.makeQuery("/service/addAudit", { dataRequest: dataRequest })
        .then((result) => {
          this.showNotification(
            "custom-success",
            dataRequest.serial,
            "Отправлено"
          );

          for (let i = 0; i < this.questions.length; i++) {
            this.questions[i].answer = null;
            this.checker = null;
            this.shiftNumber = null;
            this.serial = null;

            this.showBtnSend = false;
            this.show_props = false;
            this.show_questions = false;
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
  },
  computed: {},
  components: {},
  mounted() {},
  watch: {
    serial(newValue, oldValue) {
      if (this.isValid(newValue)) {
        this.show_questions = true;
      } else {
        this.show_questions = false;
      }
    },
  },
  created() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Audit.vue